export const LOCAL_STORAGE_LOCALE = "app-locale";
